import { render, staticRenderFns } from "./reserve-course.vue?vue&type=template&id=5b828852&"
import script from "./reserve-course.vue?vue&type=script&lang=ts&"
export * from "./reserve-course.vue?vue&type=script&lang=ts&"
import style0 from "./reserve-course.vue?vue&type=style&index=0&id=5b828852&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports